var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsCampsClinics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.308,
    height: 27.396,
    viewBox: "0 0 39.308 27.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_",
    transform: "translate(0 -50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M90,223.564v3.573h3.573v-7.148H90Z",
    transform: "translate(-79.28 -149.741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M150,223.564v3.573h3.573v-7.148H150Z",
    transform: "translate(-132.133 -149.741)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6_",
    width: 3.573,
    height: 5.956,
    transform: "translate(10.72 60.719)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7_",
    width: 3.573,
    height: 5.956,
    transform: "translate(17.867 60.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M210,223.564v3.573h3.573v-7.148H210Z",
    transform: "translate(-184.986 -149.741)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_9_",
    width: 3.573,
    height: 5.956,
    transform: "translate(25.014 60.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    d: "M0,51.8V75.619a1.787,1.787,0,0,0,1.787,1.787h5.36V68.5c0-.009,0-.018,0-.028s0-.018,0-.028V58.969c0-.009,0-.018,0-.028s0-.018,0-.028v-8.9H1.787A1.787,1.787,0,0,0,0,51.8Z",
    transform: "translate(0 -0.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M90,51.794v5.358h3.573V50.007H90Z",
    transform: "translate(-79.28 -0.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M150,51.792V57.15h3.573V50.005H150Z",
    transform: "translate(-132.133 -0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    d: "M275.36,50H270V77.4h5.36a1.787,1.787,0,0,0,1.787-1.787V51.787A1.787,1.787,0,0,0,275.36,50Z",
    transform: "translate(-237.839)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    d: "M210,51.79v5.358h3.573V50H210Z",
    transform: "translate(-184.986 -0.003)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCampsClinics);
export default __webpack_public_path__ + "static/media/icons-camps-clinics.caa76e14d69b97ece6880fa47361f410.svg";
export { ForwardRef as ReactComponent };